import { InputLabel } from '@mui/material';

export type TextAreaPopoutInputLabelProps = {
    label: string;
};

export const TextAreaPopoutInputLabel = ({ label }: TextAreaPopoutInputLabelProps) => {
    return (
        <InputLabel
            sx={{
                fontSize: '12px',
                padding: '0px'
            }}
        >
            {label}
        </InputLabel>
    );
};
